import axios from '@pepper/utils/src/function/axiosInstance'
import { useQuery } from '@tanstack/react-query'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

import { KeywordThemes } from '../types'

type ReturnType = {
  themes?: KeywordThemes[]
  status?: number
  isLoading: boolean
  isFetching: boolean
  refetch: () => void
  error: unknown
}

type Parameters = {
  companyId: string
  domainId: string
  categoryId?: string
  enabled?: boolean
  isStale?: boolean
}

const fetchThemes = async ({
  companyId,
  domainId,
  categoryId,
}: Parameters): Promise<any> => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/keyword-discovery/domains/${domainId}/themes`
  const response = await axios.get(url, {
    params: {
      category_id: categoryId,
    },
  })

  return response
}

export const useKeywordThemes = ({
  companyId,
  domainId,
  categoryId,
  enabled = false,
  isStale = false,
}: Parameters): ReturnType => {
  const {
    isLoading,
    isFetching,
    error,
    refetch,
    data: response,
  } = useQuery<any>({
    queryKey: ['keyword-themes', companyId, domainId, categoryId],
    queryFn: () =>
      fetchThemes({
        companyId,
        categoryId,
        domainId,
      }),
    enabled,
    refetchOnWindowFocus: false,
    staleTime: isStale ? Number.POSITIVE_INFINITY : 0,
  })

  return {
    themes: response?.data?.data,
    status: response?.status,
    isLoading,
    isFetching,
    refetch,
    error,
  }
}
